(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["splash"] && !Shopify.designMode) return;
  try {
    
  var _popupEl = document.getElementById('newsletter-popup');
  var POPUP_DELAY_MS = (_popupEl ? parseInt(_popupEl.getAttribute('data-popup-delay') || '3', 10) : 3) * 1000;

  function dismissPopup() {
    var $popup = $('#newsletter-popup');
    $popup.attr('aria-hidden', 'true');
    $popup.css('transition', 'opacity 0.4s ease');
    $popup.css('opacity', '0');
    setTimeout(function () {
      $popup.css('display', 'none');
    }, 400);
  }

  function showPopup() {
    if (!$('#newsletter-popup').length) return;
    var $popup = $('#newsletter-popup');
    $popup.css({ display: 'flex', opacity: '0' });
    $popup.attr('aria-hidden', 'false');
    setTimeout(function () {
      $popup.css('transition', 'opacity 0.4s ease');
      $popup.css('opacity', '1');
      $popup.find('.newsletter-popup__box').focus();
    }, 20);
  }

  // If already seen this session, remove immediately without animation
  if (sessionStorage.getItem('splash_seen')) {
    var $s = $('.splash');
    $s.remove();
    $('.page-container').css('transform', '');
    $('.page-container').css('transition', '');
  } else {
    $('.page-container').css('transition', 'initial');
    $('.page-container').css('transform', 'initial');

    // Move focus into the splash so screen readers announce it immediately
    $(document).ready(function () {
      $('.splash').focus();
    });

    function dismissSplash($splash) {
      sessionStorage.setItem('splash_seen', '1');
      $splash.attr('aria-hidden', 'true');
      $splash.css('transition', 'opacity 0.5s ease');
      $splash.css('opacity', '0');
      setTimeout(function () {
        $splash.remove();
        $('.page-container').css('transform', '');
        $('.page-container').css('transition', '');
        window.scrollTo(0, 0);
        // Schedule newsletter popup after delay
        setTimeout(showPopup, POPUP_DELAY_MS);
      }, 500);
    }

    $('body').on('click', '.splash', function (e) {
      e.preventDefault();
      dismissSplash($(this));
    });

    $('body').on('keydown', '.splash', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        dismissSplash($(this));
      }
    });
  }

  // Popup close button
  $('body').on('click', '.newsletter-popup__close', function () {
    dismissPopup();
  });

  // Click outside popup box to close
  $('body').on('click', '.newsletter-popup__overlay', function () {
    dismissPopup();
  });

  // Escape key to close
  $(document).on('keydown', function (e) {
    if (e.key === 'Escape' && $('#newsletter-popup').attr('aria-hidden') === 'false') {
      dismissPopup();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
